var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2567 0H2.7433C1.22822 0 0 1.2279 0 2.7426C0 4.25729 1.22822 5.48519 2.7433 5.48519H29.2567C30.7718 5.48519 32 4.25729 32 2.7426C32 1.2279 30.7718 0 29.2567 0Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2567 12.3438H2.7433C1.22822 12.3438 0 13.5717 0 15.0863C0 16.601 1.22822 17.8289 2.7433 17.8289H29.2567C30.7718 17.8289 32 16.601 32 15.0863C32 13.5717 30.7718 12.3438 29.2567 12.3438Z",
    fill: "#575757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2567 24.6855H2.7433C1.22822 24.6855 0 25.9134 0 27.4281C0 28.9428 1.22822 30.1707 2.7433 30.1707H29.2567C30.7718 30.1707 32 28.9428 32 27.4281C32 25.9134 30.7718 24.6855 29.2567 24.6855Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6ba8c4da47a75dc0ed0537b760f7eb4d.svg";
export { ForwardRef as ReactComponent };